import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/algorithm'

const AlgorithmApi = {
  generateHoliday (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/generate-holiday`,
      input,
      success,
      failure,
      { couldCancel: false }
    )
  },
  getNextBusinessDay (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/next-business/day`,
      input,
      success,
      failure,
      { couldCancel: false }
    )
  },
  isValidatePhone (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/isValidateNum`,
      input,
      success,
      failure,
      { couldCancel: false }
    )
  }
}
export { AlgorithmApi }
